export default __webpack_public_path__ + "static/media/structureeconomiesociale.103ad4ad.jpg";